// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"logo-marque_wrapper__26gnF","gradient-left":"logo-marque_gradient-left__3GBRs","gradient-right":"logo-marque_gradient-right__KvSb9"};